const state = () => ({
    user_preference: {},
})

const mutations = {
    setUserPreference(state, option: { key: string; value: any }): void {
        state.user_preference[option.key] = option.value
    },
}

const actions = {
    async setUserPreference({ commit }, option: { key: string; value: any }): Promise<void> {
        await commit('setUserPreference', option)
    },
}

const getters = {
    user_preference: (state) => (key) => state.user_preference[key],
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
